import { render, staticRenderFns } from "./AuthoriseMisc.vue?vue&type=template&id=85df1858&scoped=true"
import script from "./AuthoriseMisc.vue?vue&type=script&lang=js"
export * from "./AuthoriseMisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df1858",
  null
  
)

export default component.exports